import { render, staticRenderFns } from "./BuildingNavigation.vue?vue&type=template&id=11e8f618&"
import script from "./BuildingNavigation.vue?vue&type=script&lang=js&"
export * from "./BuildingNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e8f618')) {
      api.createRecord('11e8f618', component.options)
    } else {
      api.reload('11e8f618', component.options)
    }
    module.hot.accept("./BuildingNavigation.vue?vue&type=template&id=11e8f618&", function () {
      api.rerender('11e8f618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BuildingNavigation.vue"
export default component.exports